import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvBookingEditorForm.html?raw';
import topic from 'dojo/topic';
import "../EvBookingEditorTypes";
import DateTimeInput from '../../../moreCore/UI/DateTimeInput/DateTimeInput';
import '../../../moreCore/UI/DateTimeInput/DateTimeInput';
import Edit from '../../../moreCore/UI/Edit/Edit';
import '../../../moreCore/UI/Edit/Edit';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import '../../../moreCore/UI/CheckBox/CheckBox';
import HintBox from '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import "../../../moreCore/UI/SearchSelect/SearchSelect";
import SelectEntityDialog from '../../../moreCore/UI/SelectEntityDialog/SelectEntityDialog';
import '../../../moreCore/UI/SelectEntityDialog/SelectEntityDialog';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import _StatefulBase from '../../../moreCore/UI/_StatefulBase/_StatefulBase';
import "../../../moreCore/UI/_StatefulBase/_StatefulBase";
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import EvProgramEditor from '../EvProgramEditor/EvProgramEditor';
import '../EvProgramEditor/EvProgramEditor';
import dojoDate from 'dojo/date';

import '../OverlappingBookingsView/OverlappingBookingsView';
import OverlappingBookingsView from '../OverlappingBookingsView/OverlappingBookingsView';

//import EvCastEditor = require("../EvCastEditor/EvCastEditor");
//import "../EvCastEditor/EvCastEditor";

//import ServiceEditor = require("../ServiceEditor/ServiceEditor");
//import "../ServiceEditor/ServiceEditor";

//import EvCategoriesEditor = require("../EvCategoriesEditor/EvCategoriesEditor");
//import "../EvCategoriesEditor/EvCategoriesEditor";

//import EvTaskEditor = require("../EvTaskEditor/EvTaskEditor");
//import "../EvTaskEditor/EvTaskEditor";

//import FilesEditor = require("../FilesEditor/FilesEditor");
//import "../FilesEditor/FilesEditor";

import {
    ProjectWizard,
    EvCastEditor,
    ServiceEditor,
    EvCategoriesEditor,
    EvTaskEditor,
    FilesEditor,
    VAMtypes,
    VAMclassNames,
    EvBookingEditor
} from "../../../WidgetCollection/_loadingHelpers/VAM";

import _GlobalSelectEntityDialogsMixin from '../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';

/*
import EvProgramEditor = require('../EvProgramEditor/EvProgramEditor');
import '../EvProgramEditor/EvProgramEditor';

import EvCastEditor = require("../EvCastEditor/EvCastEditor");
import "../EvCastEditor/EvCastEditor";
*/

import on from 'dojo/on';
import NumberInput from '../../../moreCore/UI/NumberInput/NumberInput';

import FileUpload from '../../../moreCore/UI/Filetransfer/FileUpload/FileUpload';
import "../../../moreCore/UI/Filetransfer/FileUpload/FileUpload";
import domStyle from 'dojo/dom-style';
import FileUploadDisplay_ListRow from '../../../moreCore/UI/Filetransfer/FileUpload/FileUploadDisplay_ListRow/FileUploadDisplay_ListRow';
import ExpandableSection from '../../../moreCore/UI/Container/ExpandableSection';
import { ExpandableSectionMarkings, HTMLElementWithExpander } from "../../../moreCore/UI/Container/ExpandableSectionTypes";
import Tooltip from '../../../moreCore/UI/Floating/Tooltip';


interface EvBookingEditor_TableConfig {
    name: EvBookingEditor_ListNames,
    staticTable: MdsLax<InstanceType<typeof StaticTable>>,
    tableContainer: HTMLElement,
    sectionContainer: HTMLElementWithExpander,
    tableLayout: StaticTable.RowConfig,
    isVisible: boolean
}
class EvBookingEditorForm extends compose(_WidgetBaseSP, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    evBookingEditorSectionsConfig: EvBookingEditor_SectionsConfig = null;

    bookerInput: MdsLax<InstanceType<typeof SearchSelect>>;
    bookerInputSection_container: HTMLElement;
    bookerInput_container: HTMLElement;

    bookingTitleInput: MdsLax<InstanceType<typeof Edit>>;
    evProjectInput: MdsLax<InstanceType<typeof HintBox>>;
    selectEntityDlg: MdsLax<InstanceType<typeof SelectEntityDialog<any>>>;
    dateStartInput: MdsLax<InstanceType<typeof DateTimeInput>>;
    dateEndInput: MdsLax<InstanceType<typeof DateTimeInput>>;
    isFullTime: MdsLax<InstanceType<typeof CheckBox>>;
    roomInput: MdsLax<InstanceType<typeof HintBox>>;
    ticketsCapacity: MdsLax<InstanceType<typeof NumberInput>>;
    ticketsEstimated: MdsLax<InstanceType<typeof NumberInput>>;
    activityStatusInput: MdsLax<InstanceType<typeof SearchSelect>>;
    audienceSeatingLayoutInput: MdsLax<InstanceType<typeof SearchSelect>>;
    bookingStatusInput: MdsLax<InstanceType<typeof SearchSelect>>;
    onlyVacantRoomsInput: MdsLax<InstanceType<typeof CheckBox>>;
    noteInput: HTMLTextAreaElement;
    evCategoriesEditor: MdsLax<InstanceType<typeof EvCategoriesEditor>>;
    castEditor: MdsLax<InstanceType<typeof EvCastEditor>>;
    programEditor: MdsLax<InstanceType<typeof EvProgramEditor>>;

    //bookingCast: StaticTable;
    //bookingProgram: StaticTable;
    //bookingServices: StaticTable;
    //evTasksTable: StaticTable;
    //evCategoriesTable: StaticTable;
    //bookingOrchesterEmployment: StaticTable;
    //existingFilesTable: StaticTable;
    //programDlg: GenericDialog;
    //castProgram: StaticTable;
    //castDlg: GenericDialog;

    oversteeredPriceCheckbox: MdsLax<InstanceType<typeof CheckBox>>;
    freePriceCheckbox: MdsLax<InstanceType<typeof CheckBox>>;
    priceTotalPricelistCheckbox: MdsLax<InstanceType<typeof CheckBox>>;

    numberInput_PriceUnitChange: MdsLax<InstanceType<typeof NumberInput>>;
    numberInput_PriceUnitPricelist: MdsLax<InstanceType<typeof NumberInput>>;
    numberInput_PriceTotalPricelist: MdsLax<InstanceType<typeof NumberInput>>;
    numberInput_ValueAgiodisagioUnit: MdsLax<InstanceType<typeof NumberInput>>;
    numberInput_ValueAgiodisagioTotal: MdsLax<InstanceType<typeof NumberInput>>;
    numberInput_Discount: MdsLax<InstanceType<typeof NumberInput>>;
    numberInput_ValueDiscountUnit: MdsLax<InstanceType<typeof NumberInput>>;
    numberInput_ValueDiscountTotal: MdsLax<InstanceType<typeof NumberInput>>;
    numberInput_PriceUnitAfterDisc: MdsLax<InstanceType<typeof NumberInput>>;
    numberInput_PriceTotalAfterDisc: MdsLax<InstanceType<typeof NumberInput>>;
    numberInput_VatValue: MdsLax<InstanceType<typeof NumberInput>>;
    numberInput_PriceTotalInclVat: MdsLax<InstanceType<typeof NumberInput>>;

    inputSelectedAssociate: MdsLax<InstanceType<typeof SearchSelect>>;
    originalSelectedAssociateValue: string = "";
    selectedAssociateData: any = {};

    bookingTitleInput_container: HTMLElement;
    evProjectInput_container: HTMLElement;
    ticketsSection_container: HTMLElement;
    dateStartInput_container: HTMLElement;
    dateEndInput_container: HTMLElement;
    roomInput_container: HTMLElement;
    audienceSeatingLayoutContainer: HTMLElement;
    activityStatusInput_container: HTMLElement;
    bookingStatusInput_container: HTMLElement;
    noteInput_container: HTMLElement;
    onlyVacantRoomsInput_container: HTMLElement;
    showIfDatesAreSet: HTMLElement;
    sendButton: HTMLButtonElement;
    sendButtonContainer: HTMLElement;
    deleteButtonContainer: HTMLElement;
    deleteButton: HTMLButtonElement;
    calculateButton: HTMLButtonElement;
    saveAssociate: HTMLButtonElement;

    bookingCastTableContainer: HTMLElement;
    bookingProgramTableContainer: HTMLElement;
    serviceTableContainer: HTMLElement;
    servicePricesEditorContainer: HTMLElement;
    pricelistMessageContainer: HTMLElement;
    evTaskMessageContainer: HTMLElement;
    orchesterEmploymentTableContainer: HTMLElement;
    castContainer: HTMLElementWithExpander;
    programContainer: HTMLElementWithExpander;
    serviceContainer: HTMLElementWithExpander;
    evTaskContainer: HTMLElementWithExpander;
    evTaskAssociateEditorContainer: HTMLElement;
    evCategoryContainer: HTMLElementWithExpander;
    orchesterEmploymentContainer: HTMLElementWithExpander;
    filesSectionContainer: HTMLElementWithExpander;
    bookingEvTaskTableContainer: HTMLElement;
    bookingEvCategoryTableContainer: HTMLElement;

    controllerUrl: any = window.appRoot + "EvBookingEditor";
    bookingDateStart: Date = null;
    bookingDateEnd: Date = null;

    editedServiceBooking: any = null;

    allValues: {} = {};

    evTaskEditor_container: HTMLElement;
    evTaskEditor: MdsLax<InstanceType<typeof EvTaskEditor>>;

    fileUpload: MdsLax<InstanceType<typeof FileUpload>>;
    fileCategories: Array<{ ID: string, description: string }> = [];
    bookingFilesTableContainer: HTMLElement;
    newUploadFiles: any[] = [];

    bookingListTablesConfig: {
        cast: EvBookingEditor_TableConfig,
        program: EvBookingEditor_TableConfig,
        service: EvBookingEditor_TableConfig,
        evTasks: EvBookingEditor_TableConfig,
        evCategories: EvBookingEditor_TableConfig
        orchestraEmployments: EvBookingEditor_TableConfig,
        existingFiles: EvBookingEditor_TableConfig,
    } = null;
    markedRow: any = null;
    serviceEditor: MdsLax<InstanceType<typeof ServiceEditor>>;
    overlappingBookingsView: MdsLax<InstanceType<typeof OverlappingBookingsView>>;
    overlappingBookingsMessageContainer: HTMLDivElement;
    overlappingBookingsViewContainer: HTMLDivElement;

    castTableLayout: StaticTable.RowConfig = {
        colNamesInternal: ["c_cast_address", "c_cast_perfomer", "castAktionen"],
        "attributes": ["c_cast_address", "c_cast_perfomer"],
        "colspans": [1, 1, 1],
        "headings": [(this as any).translations["BookingEditor__castAddressTableHeader"], (this as any).translations["BookingEditor__castRoleTableHeader"], "castAktionen"],
        widths: [null, null, "15ch"],
        alignmentsHeading: [null, null, "right"],
        alignmentsRow: [null, null, "right"]
    }
    programTableLayout: StaticTable.RowConfig = {
        "attributes": ["c_composer_author", "c_opus", "duration_min"],
        colNamesInternal: ["c_composer_author", "c_opus", "duration_min", "prgAktionen"],
        "colspans": [1, 1, 1, 1],
        "headings": [(this as any).translations["BookingEditor__programAuthorHeader"], (this as any).translations["BookingEditor__programTitleHeader"], (this as any).translations["BookingEditor__programDurationHeader"], "prgAktionen"],
        widths: [null, null, "10ch", "15ch"],
        alignmentsHeading: [null, null, null, "right"],
        alignmentsRow: [null, null, null, "right"]

    }
    serviceTableLayout: StaticTable.RowConfig = {
        "attributes": ["description", "service_type_text", "quantity_text", "price_total_pricelist", ""],
        colNamesInternal: ["description", "service_type_text", "quantity_text", "price_total_pricelist", "Aktionen_WithEdit"],
        "colspans": [1, 1, 1, 1],
        "headings": [(this as any).translations["General_Description"], (this as any).translations["General_Label_Type"], (this as any).translations["General_Label_Quantity"], (this as any).translations["General_Label_Price"], "Aktionen_WithEdit"],
        widths: [null, "16ch", null, "10ch", "18ch"],
        alignmentsHeading: [null, null, null, null, "right"],
        alignmentsRow: [null, null, null, null, "right"]
    }

    evTaskTableLayout: StaticTable.RowConfig = {
        "attributes": ["ref_task_description.description", "ref_vt_address_backoffice.gDisp_1"],
        colNamesInternal: ["ref_task_description.description", "ref_vt_address_backoffice.gDisp_1", "Aktionen_EditDelete"],
        "colspans": [1, 1, 1],
        "headings": ["Diensttyp", "Mitarbeiter", "Aktionen_EditDelete"],
        widths: [null, null, "10ch"],
        alignmentsHeading: [null, null, "right"],
        alignmentsRow: [null, null, "right"]
    };

    evCategoriesTableLayout: StaticTable.RowConfig = {
        "attributes": ["code", "description"],
        colNamesInternal: ["code", "description", "Aktionen_DeleteOnly"],
        "colspans": [1, 1, 1],
        "headings": [(this as any).translations["General_Label_Code"], (this as any).translations["General_Description"], "Aktionen_DeleteOnly"],
        widths: ["10ch", null, "10ch"],
        alignmentsHeading: [null, null, "right"],
        alignmentsRow: [null, null, "right"]

    }

    orchesterEmploymentTableLayout: StaticTable.RowConfig = {
        "attributes": ["ref_associate.gDisp_Name_Firstname", "ref_functional_group.description", "ref_vt_duty_type.code"],
        colNamesInternal: ["ref_associate.gDisp_Name_Firstname", "ref_functional_group.description", "ref_vt_duty_type.code"],
        "colspans": [1, 1, 1],
        "headings": [(this as any).translations["EmploymentFinder__musician"], (this as any).translations["EmploymentFinder__functionalGroup"], (this as any).translations["EmploymentFinder__employmentType"]]
    }

    existingFilesTableLayout: StaticTable.RowConfig = {
        "attributes": ["filename", "keyword", "ref_file_category.description"],
        colNamesInternal: ["filename", "keyword", "ref_file_category.description", "Aktionen_DownloadDelete"],
        "colspans": [1, 1, 1, 1],
        "headings": [(this as any).translations["General_Label_Filename"], (this as any).translations["General_Label_Keyword"], (this as any).translations["General_Label_Category"], "Aktionen_DownloadDelete"],
        widths: [null, null, null, "10ch"],
        alignmentsHeading: [null, null, null, "right"],
        alignmentsRow: [null, null, null, "right"]
    }

    table_formatterFunction__headingLabel: Function = lang.hitch(this, function (headingLabel: string) {
        switch (headingLabel) {
            case "Aktionen_DeleteOnly":
            case "Aktionen_DownloadDelete":
            case "Aktionen_WithEdit":
            case "Aktionen_EditDelete":
            case "castAktionen":
            case "srvAktionen":
            case "prgAktionen":
                return (this as any).translations["General_Label_Actions"];
        }

        return headingLabel;
    });

    table_formatterFunction(cell: StaticTable.StaticTableCell<object>) {
        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;
        let rowIndex = cell.tableRow.rowGroup.rowIndex;

        //console.log("rowIndex", rowIndex);
        //console.log("NODE", node, "ENTITY", entity, "colName", colName, "VALUE", value, "ROW INDEX", rowIndex, "CELL", cell);
        if ((entity["Classname"] == "service_ev_serv" || entity["Classname"] == "pos_ev_serv") && entity["service_type"] === 1) {

            domStyle.set(cell.tableCellNode, "vertical-align", "middle");
        }

        let isRed: boolean; //= (entity["Classname"] == "ev_program" || entity["Classname"] == "opus") && (entity["is_red_entry"] || entity["ref_opus"] === null);

        switch (entity["Classname"]) {
            case "ev_program":
            case "opus":
                isRed = entity["is_red_entry"] || entity["ref_opus"] === null;
                break;
            case "ev_cast":
            case "performers":
                isRed = entity["is_red_entry"] || entity["ref_performer"] === null;
                break;
            default:
                isRed = false;
        }

        if (isRed && colName.indexOf("Aktionen") == -1) this.UiModder.domClass.add(node, "w3-text-red");

        //cell.formattingHandled = true;
        let icon = null;
        switch (colName) {
            case this.translations["BookingEditor__programDurationHeader"]:
            case "duration_min":
                node.innerHTML = value + " min";
                return true;
                break;

            case "Aktionen_WithEdit":

                icon = this.createFontawesomeIcon("fas fa-edit hoverTxtPrimary secondaryText w3-margin-right", "", node);
                on(icon, "click", lang.hitch(this, this._onClick_TableRowAction, entity, rowIndex, "edit", cell.tableRow));

                if ((entity["Classname"] == "service_ev_serv" || entity["Classname"] == "pos_ev_serv") && entity["service_type"] != 1) {
                    this.UiModder.domClass.add(icon, "w3-disabled");
                }

                icon = this.createFontawesomeIcon("fas fa-chevron-circle-up hoverTxtPrimary secondaryText w3-margin-right", "", node);
                on(icon, "click", lang.hitch(this, this._onClick_TableRowAction, entity, rowIndex, "moveup", cell.tableRow));
                icon = this.createFontawesomeIcon("fas fa-chevron-circle-down hoverTxtPrimary secondaryText w3-margin-right", "", node);
                on(icon, "click", lang.hitch(this, this._onClick_TableRowAction, entity, rowIndex, "movedown", cell.tableRow));

                icon = this.createFontawesomeIcon("fas fa-trash hoverTxtPrimary secondaryText warningTXT", "", node);
                on(icon, "click", lang.hitch(this, this._onClick_TableRowAction, entity, rowIndex, "delete", cell.tableRow));

                return true;
                break;
            case "Aktionen_EditDelete":
                icon = this.createFontawesomeIcon("fas fa-edit hoverTxtPrimary secondaryText w3-margin-right", "", node);
                on(icon, "click", lang.hitch(this, this._onClick_TableRowAction, entity, rowIndex, "edit", cell.tableRow));

                icon = this.createFontawesomeIcon("fas fa-trash hoverTxtPrimary secondaryText warningTXT", "", node);
                on(icon, "click", lang.hitch(this, this._onClick_TableRowAction, entity, rowIndex, "delete", cell.tableRow));

                return true;
                break;
            case "Aktionen_DeleteOnly":
                icon = this.createFontawesomeIcon("fas fa-trash hoverTxtPrimary secondaryText warningTXT", "", node);
                on(icon, "click", lang.hitch(this, this._onClick_TableRowAction, entity, rowIndex, "delete", cell.tableRow));
                return true;
                break;
            case "Aktionen_DownloadDelete":
                icon = this.createFontawesomeIcon("fas fa-download hoverTxtPrimary secondaryText w3-margin-right", "", node);
                on(icon, "click", lang.hitch(this, this._onClick_TableRowAction, entity, rowIndex, "download", cell.tableRow));

                let disabled = "";
                if (!entity["ref_entity_1"] || entity["ref_entity_1"]["ID"] !== this.existingEntity.ID) disabled = "w3-disabled";
                icon = this.createFontawesomeIcon(`fas fa-trash hoverTxtPrimary secondaryText warningTXT ${disabled}`, "", node);
                on(icon, "click", lang.hitch(this, this._onClick_TableRowAction, entity, rowIndex, "delete", cell.tableRow));

                return true;
                break;
            case "Aktionen":
            case "castAktionen":
            case "prgAktionen":
                icon = this.createFontawesomeIcon("fas fa-chevron-circle-up hoverTxtPrimary secondaryText w3-margin-right", "", node);
                on(icon, "click", lang.hitch(this, this._onClick_TableRowAction, entity, rowIndex, "moveup", cell.tableRow));
                icon = this.createFontawesomeIcon("fas fa-chevron-circle-down hoverTxtPrimary secondaryText w3-margin-right", "", node);
                on(icon, "click", lang.hitch(this, this._onClick_TableRowAction, entity, rowIndex, "movedown", cell.tableRow));

                icon = this.createFontawesomeIcon("fas fa-trash hoverTxtPrimary secondaryText warningTXT", "", node);
                on(icon, "click", lang.hitch(this, this._onClick_TableRowAction, entity, rowIndex, "delete", cell.tableRow));
                return true;
                break;
            case this.translations["General_Label_Quantity"]:

                if (entity["service_type"] === 1) {

                    let numberInput = new NumberInput();
                    numberInput.setValue(entity["quantity_multiplier"]);
                    numberInput.placeAt(node);
                    numberInput.setUnit(value);

                    on(numberInput, "change", lang.hitch(this, this._onChange_ServiceQuantity, entity));
                } else {

                    node.innerHTML = value;
                }
                return true;
                break;
            case this.translations["General_Label_Price"]:

                if (entity["service_type"] === 1) {

                    if (entity["state"] === "new") {

                        node.innerHTML = "<i>" + this.translations["EvBookingditor_ToCalculate"] + "</i>";
                    }
                    else {

                        node.innerHTML = parseFloat(value).toFixed(2) + " €";
                    }
                } else {

                    node.innerHTML = "";
                }
                return true;
                break;

            case this.translations["General_Description"]:

                if (entity["Classname"] == "service_ev_serv" || entity["Classname"] == "pos_ev_serv") {

                    on(node, "click", lang.hitch(this, this._onClick_TableRowAction, entity, rowIndex, false, cell.tableRow));
                }

                node.innerHTML = value;
                return true;
                break;

            case "Mitarbeiter":
                value ? node.innerHTML = value : node.innerHTML = "N.A.";
                return true;
                break;

            default:
                return false;
        }
    }

    // die setzen wir programmatisch, nicht im Template
    private mandatoryFields: Array<string> = ["bookingTitleInput", "evProjectInput", "dateStartInput", "dateEndInput", "roomInput", "activityStatusInput", "bookingStatusInput"];

    allFields: Array<string> = ["bookingTitleInput",
        //bookerInput",
        "evProjectInput",
        "dateStartInput",
        "dateEndInput",
        "isFullTime",
        "roomInput",
        "ticketsCapacity",
        "ticketsEstimated",
        "activityStatusInput",
        "bookingStatusInput",
        "audienceSeatingLayoutInput",
        "noteInput"];

    bookingAttributesForFields: Array<string> = ["ev_booking_name",
        "gDisp_1",
        "$Displayname",
        "date_start",
        "date_end",
        "is_full_time",
        "ref_ev_room.description",
        "tickets_capacity",
        "tickets_estimated",
        "ref_ev_activity_status.description",
        "ref_ev_booking_status.description",
        "ref_audience_seating_layouts.gDisp_1",
        "note"];

    // values set from parent widget, if such exists
    isValidationEnabled: boolean = true;
    _isFormInDialog: boolean = false;
    _request: any = null;
    private saveDataUrl: string = window.appRoot + "EvBookingEditor/SaveFormData";

    bookingStatusPresetValue: string | {} = null;
    activityStatusPresetValue: string | {} = null;
    audienceSeatingLayoutPresetValue: string | {} = null;
    evProjectPresetValue: string | {} = null;
    bookerInputPresetValue: string | {} = null;

    originalEntityValues: {} = null;

    existingEntity: { ID: string } = null;
    editorFormConfig: any = {
        bookingTitleInput: "ev_booking_name",
        bookerInput: "ref_booker.ID",
        evProjectInput: "ref_ev_project",
        dateStartInput: "date_start",
        dateEndInput: "date_end",
        isFullTime: "is_full_time",
        roomInput: "ref_ev_room",
        ticketsCapacity: "tickets_capacity",
        ticketsEstimated: "tickets_estimated",
        activityStatusInput: "ref_ev_activity_status.ID",
        bookingStatusInput: "ref_ev_booking_status.ID",
        audienceSeatingLayoutInput: "ref_audience_seating_layouts.ID",
        noteInput: "note"
    };

    // --------------------------inputEvents -----------------------START
    private _onChange_ServiceQuantity(entity: any, value): void {

        entity["quantity_multiplier"] = value;

        if (this.editedServiceBooking != null) {

            this.editedServiceBooking = null
            this.UiModder.domClass.remove(this.pricelistMessageContainer, "w3-hide");
            this.UiModder.domClass.add(this.servicePricesEditorContainer, "w3-hide");
        }
    }

    //private _onChange_ServicePrice(entity: any, value): void {

    //    entity["price_total_pricelist"] = value;
    //}

    private _onClick_TableRowAction(
        entity: any,
        rowIndex: number,
        actionType: "delete" | "edit" | "moveup" | "movedown" | "download",
        row: any = null,
        evt: any
    ): void {
        console.log("TableRowClick", evt.target);
        let entityClass: VAMclassNames = entity["Classname"];
        let entityID = entity["ID"];
        if (!entityID) entityID = entity["GUID"]; // kann temporär bei neuen Entities sein
        let entityState: "new" | "deleted" = entity["state"];

        // Pricelist table
        //if (isPriceClick && (entity["Classname"] == "service_ev_serv" || entity["Classname"] == "pos_ev_serv") && entity["service_type"] == 1) {
        if (actionType == "edit") {

            if ((entityClass == VAMclassNames.service_ev_serv ||
                entityClass == VAMclassNames.pos_ev_serv) && entity["service_type"] == 1) {

                if (!this.checkIsFormDirty()) {

                    if (this.markedRow) {
                        this.UiModder.domClass.remove(this.markedRow, "EvBookingEditorForm selectedTableRow");
                        this.markedRow = null;
                    }

                    this.markedRow = row.node;
                    this.UiModder.domClass.add(this.markedRow, "EvBookingEditorForm selectedTableRow");

                    this.editedServiceBooking = { ...entity };

                    this.UiModder.domClass.remove(this.servicePricesEditorContainer, "w3-hide");
                    this.UiModder.domClass.add(this.pricelistMessageContainer, "w3-hide");

                    this.oversteeredPriceCheckbox.setValue(entity["is_oversteered_price"], true);
                    this.freePriceCheckbox.setValue(!entity["ref_pricelist"], true);
                    this.priceTotalPricelistCheckbox.setValue(entity["is_price_total_pricelist"], true);
                    this._onPriceCheckboxInputs();

                    this.numberInput_PriceUnitChange.setValue(entity["price_unit_change"], true);
                    this.numberInput_PriceUnitPricelist.setValue(entity["price_unit_pricelist"], true);
                    this.numberInput_PriceTotalPricelist.setValue(entity["price_total_pricelist"], true);
                    this.numberInput_ValueAgiodisagioUnit.setValue(entity["value_agiodisagio_unit"], true);
                    this.numberInput_ValueAgiodisagioTotal.setValue(entity["value_agiodisagio_total"], true);
                    this.numberInput_Discount.setValue(entity["discount"], true);
                    this.numberInput_ValueDiscountUnit.setValue(entity["value_discount_unit"], true);
                    this.numberInput_ValueDiscountTotal.setValue(entity["value_discount_total"], true);
                    this.numberInput_PriceUnitAfterDisc.setValue(entity["price_unit_after_disc"], true);
                    this.numberInput_PriceTotalAfterDisc.setValue(entity["price_total_after_disc"], true);
                    this.numberInput_VatValue.setValue(entity["VAT_value"], true);
                    this.numberInput_PriceTotalInclVat.setValue(entity["price_total_incl_VAT"], true);

                } else {

                    this.UiModder.domClass.remove(this.pricelistMessageContainer, "w3-hide");
                }
            }

            if (entityClass == VAMclassNames.ev_task_single || entityClass == VAMclassNames.ev_task_descript) {
                if (!this.checkIsFormDirty()) {

                    if (this.markedRow) {
                        this.UiModder.domClass.remove(this.markedRow, "EvBookingEditorForm selectedTableRow");
                        this.markedRow = null;
                    }

                    this.markedRow = row.node;
                    this.UiModder.domClass.add(this.markedRow, "EvBookingEditorForm selectedTableRow");

                    this.inputSelectedAssociate.setValue(null, true);
                    this.selectedAssociateData = {};

                    this.UiModder.domClass.add(this.saveAssociate, "w3-disabled");

                    entity["ref_vt_address_backoffice"] ? this.originalSelectedAssociateValue = entity["ref_vt_address_backoffice"]["ID"] : this.originalSelectedAssociateValue = "";
                    console.debug("this.originalSelectedAssociateValue", this.originalSelectedAssociateValue);
                    this.inputSelectedAssociate.loadListValues(this.originalSelectedAssociateValue, true);

                    this.UiModder.domClass.remove(this.evTaskAssociateEditorContainer, "w3-hide");
                    this.UiModder.domClass.add(this.evTaskMessageContainer, "w3-hide");

                    this.selectedAssociateData["ID"] = entity["ID"];
                    this.selectedAssociateData["Classname"] = entity["Classname"];

                } else {

                    this.UiModder.domClass.remove(this.evTaskMessageContainer, "w3-hide");
                    this.UiModder.domClass.add(this.evTaskAssociateEditorContainer, "w3-hide");
                }
            }

            return;
        } else {

            if (this.markedRow) {
                this.UiModder.domClass.remove(this.markedRow, "EvBookingEditorForm selectedTableRow");
                this.markedRow = null;
            }

            this.editedServiceBooking = null;
            this.hideNode(this.servicePricesEditorContainer);
            this.hideNode(this.pricelistMessageContainer);
            this.hideNode(this.evTaskAssociateEditorContainer);
            this.hideNode(this.evTaskMessageContainer);

            this.originalSelectedAssociateValue = "";
        }

        // listName für Aktion
        let listName: string;
        if (entityClass == "ev_cast" || entityClass == "performers") listName = EvBookingEditor_ListNames.EvCast;
        if (entityClass == "ev_program" || entityClass == "opus") listName = EvBookingEditor_ListNames.EvProgram;
        if (entityClass == "service_ev_serv" || entityClass == "pos_ev_serv") listName = EvBookingEditor_ListNames.EvService;
        if (entityClass == "ht_evbooking_evcategorie1" || entityClass == "ev_catagories_1") listName = EvBookingEditor_ListNames.evCategories;
        if (entityClass == "ev_task_single" || entityClass == "ev_task_descript" || entity["ref_task_description"]) listName = EvBookingEditor_ListNames.evTasks;
        if (entityClass == "file_ev_project") listName = EvBookingEditor_ListNames.existingFiles;

        // Aktion
        if (actionType == "moveup") {
            // rauf
            this.moveUp(this.existingEntity[listName], entity);
            this.drawBookingListTable(false, this.bookingListTablesConfig[listName]);
        }

        if (actionType == "movedown") {
            // runter
            this.moveDown(this.existingEntity[listName], entity);
            this.drawBookingListTable(false, this.bookingListTablesConfig[listName]);
        }
        if (actionType == "delete") {

            // Sonderregel: wenn Leistungsbuchung mit Dienst, dann aus der tabelle löschen...
            let taskIdsToDelete = [];
            if (entityClass == VAMclassNames.service_ev_serv) {
                let svc: VAMtypes.EvService = entity;

                // bei neuen Entities gibt es ggf. eine temporäre GUID die auf targetTaskGUID gespeichert ist:
                if (entityState == "new") {
                    let guid = svc["targetTaskGUID"];
                    taskIdsToDelete.push(guid);
                } else {
                    // kann nicht sein - wenn nicht new, dann ist der Classname pos_ev_serv
                }

            } else if (entityClass == VAMclassNames.pos_ev_serv) {

                if (entityState == "new") {
                    // kann nicht sein, dann wär der classname service_ev_serv
                } else {
                    let svb: VAMtypes.EvServiceBooking = entity;
                    if (svb.evTasks && svb.evTasks.length) {
                        for (let task of svb.evTasks) {
                            taskIdsToDelete.push(task.ID);
                        }
                    }
                }
            }

            if (taskIdsToDelete.length) {
                for (let guid of taskIdsToDelete) {
                    let table: MdsLax<InstanceType<typeof StaticTable<VAMtypes.EvTaskSingle>>> = this.bookingListTablesConfig.evTasks.staticTable;
                    let row = table.getRowGroupByKeyValue(guid, entityState == "new" ? "GUID" : "ID");

                    if (row) {
                        let taskArray: Array<object> = this.existingEntity[EvBookingEditor_ListNames.evTasks];
                        taskArray.splice(row.rowIndex, 1);
                        this.drawBookingListTable(false, this.bookingListTablesConfig[EvBookingEditor_ListNames.evTasks]);
                    }
                }
            }

            // löschen
            if (entity["state"] == "new") {

                let currentArray: Array<object> = this.existingEntity[listName]; // wenn das ding nie aus der api kam, ist es neu und kann daher komplett gelöscht werden
                currentArray.splice(rowIndex, 1);
            } else {

                for (let i = 0; i < this.existingEntity[listName].length; i++) {

                    if (this.existingEntity[listName][i]["ID"] == entity["ID"]) {
                        this.existingEntity[listName][i]["state"] = "deleted";
                        //console.log("zum löschen markiert", this.existingEntity[listName][i], this.existingEntity[listName]);
                    }
                }
            }
            // neu zeichnen...
            this.drawBookingListTable(false, this.bookingListTablesConfig[listName]);
        }
        if (actionType == "download") {

            //alert("DOWNLOAD!");

            window.open(window.appRoot + `EvBookingEditor/DownloadExistingFile?downloadKey=${entity["ID"]}`)

            //console.debug("ENTITY", entity);
        }

    }

    private moveDown(list: Array<object>, entity: any, orderAttributeName: string = "order") {
        this._initOrderInList(list, orderAttributeName);

        list.filter(function (data) {
            if (data[orderAttributeName] === entity[orderAttributeName] + 1) {
                data[orderAttributeName] = data[orderAttributeName] - 1;
            }
        });
        entity[orderAttributeName]++;

        this._resortEntityList(list);
    }

    private moveUp(list: Array<object>, entity: any, orderAttributeName: string = "order") {
        this._initOrderInList(list, orderAttributeName);

        list.filter(function (data) {
            if (data[orderAttributeName] === entity[orderAttributeName] - 1) {
                data[orderAttributeName] = data[orderAttributeName] + 1;
            }
        });
        entity[orderAttributeName]--;

        this._resortEntityList(list);
    }

    private _resortEntityList(list: Array<object>, orderAttributeName: string = "order") {

        list = list.sort(function (a, b) {
            return a[orderAttributeName] - b[orderAttributeName];
        });
    }

    private _initOrderInList(list: Array<object>, orderAttributeName: string = "order") {
        for (let i = 1; i <= list.length; i++) {
            list[i - 1][orderAttributeName] = i;
        }
    }

    private _sendSelectedRoomId(): void {
        let value = this.roomInput.getValue("value");
        this.serviceEditor.setRoomId(value);
    }

    private _onNewBookingListElementFromEditor(value: any, attrArray: Array<string>): void {
        let listName: string = attrArray[0]; // aus emit() zusätzliche Attributen sind in Array
        this.addEntryToList(value, listName);
    }

    private addEntryToList(entity: any, targetListName: string): Object {

        if (this.existingEntity == null) {
            this.existingEntity = {
                ID: ""
            };
        }

        if (this.existingEntity[targetListName] == null || typeof this.existingEntity[targetListName] == "undefined") {
            this.existingEntity[targetListName] = [];
        }

        console.log(`_onNew event - ${targetListName}`, entity, "this.existingEntity[listName]", this.existingEntity[targetListName]);

        let isWithOrder: boolean = false;
        entity["state"] = "new";

        switch (targetListName) {
            case EvBookingEditor_ListNames.EvCast:
                isWithOrder = true;

                if (typeof entity == "object" && !entity["is_red_entry"]) {
                    entity["c_cast_address"] = entity.ref_address.pseudonym;
                    entity["c_cast_perfomer"] = entity.ref_ev_profession.description;
                } else if (!entity["is_red_entry"]) {
                    entity["c_cast_address"] = entity;
                    entity["c_cast_perfomer"] = "";
                }
                break;

            case EvBookingEditor_ListNames.EvProgram:
                isWithOrder = true;

                if (!entity["is_red_entry"]) {
                    entity["c_composer_author"] = entity["gDisp_composer_author"];
                    entity["c_opus"] = entity["opus_titel"];
                }
                break;

            case EvBookingEditor_ListNames.EvService:

                // achtung, wir bekommen hier  eine Leistung (svc) vom HINZUFÜGEN
                // die Tabelle will aber LeistungsBUCHUNGEN (svb) anzeigen

                let svc: VAMtypes.EvService = entity;
                let svb: VAMtypes.EvServiceBooking = svc as VAMtypes.EvServiceBooking;

                svb.service_type_text = this.translations[`service_type.${svc.service_type}`];
                if (entity.service_type === 1) {

                    svb.quantity_text = ` / ${svc.quantity} ${svc.unitCode}`;
                } else {

                    svb.quantity_text = " - ";
                }

                if (svc.ref_ev_task_descript) {
                    let createdTask = this.addEntryToList(svc.ref_ev_task_descript, EvBookingEditor_ListNames.evTasks)
                    createdTask["state"] = "skip"; // der API sagen dass sie das nicht wirklich erzeugen soll - onchanged in pit macht das
                    createdTask["GUID"] = (Math.random() * 1000 * Math.random() * 1000).toFixed(0);

                    svb["targetTaskGUID"] = createdTask["GUID"];

                }

                entity = svb;

                break;

            case EvBookingEditor_ListNames.evTasks:
                isWithOrder = true;

                entity["ref_task_description"] = {};
                entity["ref_task_description"]["description"] = entity["description"];
                entity["ref_task_description"]["ID"] = entity["ID"];
                entity["ref_vt_address_backoffice"] = {};
                entity["ref_vt_address_backoffice"]["gDisp_1"] = "N.A.";
                break;
            case EvBookingEditor_ListNames.evCategories:
                //
                break;
        }

        if (isWithOrder) entity["order"] = this.existingEntity[targetListName].length + 1;

        this.existingEntity[targetListName].push(entity);
        this.allValues[targetListName] = this.existingEntity[targetListName];
        this.drawBookingListTable(false, this.bookingListTablesConfig[targetListName]);
        //this._initOrderInList(this.allValues[listName], "order");

        return entity;
    }




    private _onClosedDialog(): void {

    }

    private _onSelect_CreateNewEvProject(selectEntityDlg: MdsLax<InstanceType<typeof SelectEntityDialog<VAMtypes.EvProjectEntity_Short>>>) {
        let projectWizard = new ProjectWizard();

        let dlg = new GenericDialog();

        dlg.addNodeToContent(projectWizard.domNode);
        dlg.keepOpen = true;
        dlg.destroyOnClose = false;

        on(projectWizard, "saveComplete", lang.hitch(this, this._onProjectWizardSaved, dlg, projectWizard));

        dlg.show(null, "projekt neu", "neues projekt", null, "okcancel", lang.hitch(this, this._onProjectWizardDlgResult, dlg, projectWizard));

        projectWizard.startup();
    }

    private _onProjectWizardDlgResult(dlg: MdsLax<InstanceType<typeof GenericDialog>>, projectWizard: MdsLax<InstanceType<typeof ProjectWizard>>, result: number) {
        if (result >= 1) { // OK/JA
            // speicherversuch
            projectWizard.save();
        } else {
            dlg.close(-1);
        }
    }

    private _onProjectWizardSaved(dlg: MdsLax<InstanceType<typeof GenericDialog>>, projectWizard: MdsLax<InstanceType<typeof ProjectWizard>>) {
        let projectID = projectWizard.getEntityId();
        let displayname = projectWizard.getDisplayname();

        dlg.close(-1);

        let tmpEntity = {};
        tmpEntity[this.evProjectInput.valueAttribute] = projectID;
        tmpEntity[this.evProjectInput.labelAttribute] = displayname;


        this.evProjectInput.setValue(tmpEntity);
    }

    private _onClick_OpenProjectSED(evt) {
        this.loadSelectEntityDialog(evt,
            "selectEvProject",
            lang.hitch(this, this._onCallback_Dlg),
            lang.hitch(this, this._onSelect_CreateNewEvProject)
        );
    }
    private _onClick_OpenRoomSED(evt) {
        this.loadSelectEntityDialog(evt,
            "selectEvRoom",
            lang.hitch(this, this._onCallback_Dlg),
            null,
            this.roomInput.getAdditionalRequestParams(true)
        );
    }
    private _onClick_OpenEvCategoriesSED(evt) {
        this.loadSelectEntityDialog(evt,
            "selectEvCategory",
            lang.hitch(this, this._onCallback_Dlg)
        );
    }
    private _onClick_OpenEvCastSED(evt) {
        this.loadSelectEntityDialog(evt,
            "selectEvCast",
            lang.hitch(this, this._onCallback_Dlg)
        );
    }
    private _onClick_OpenEvProgramSED(evt) {
        this.loadSelectEntityDialog(evt,
            "selectEvProgram",
            lang.hitch(this, this._onCallback_Dlg)
        );

    }


    private _onCallback_Dlg(mode: string, data, items) {
        // fake-entity falls das zurückgeleiferte Entity aus items[0].entry.data nicht dem entspricht das die liste erwartet
        let entity = {
            ID: items[0].entry.value, gDisp_1: items[0].entry.label
        }

        if (mode == "selectEvProject") {
            this.evProjectInput.setValue(entity)
        }

        if (mode == "selectEvRoom") {
            let room = items[0].entry.data;
            this.roomInput.setValue(room);
        }

        if (mode == "selectEvCategory") {

            this.evCategoriesEditor.categoryInput.setValue(items[0].entry.data)
        }
        if (mode == "selectEvCast") {

            this.castEditor.performerInput.setValue(items[0].entry.data);
        }
        if (mode == "selectEvProgram") {

            this.programEditor.opusInput.setValue(items[0].entry.data);
        }
        //this.previousSEDvalue = items;
    }


    private setupHintboxes() {
        this.evProjectInput.addInlineButton(lang.hitch(this, this._onClick_OpenProjectSED));
        this.roomInput.addInlineButton(lang.hitch(this, this._onClick_OpenRoomSED));
        this.evCategoriesEditor.categoryInput.addInlineButton(lang.hitch(this, this._onClick_OpenEvCategoriesSED));
        this.castEditor.performerInput.addInlineButton(lang.hitch(this, this._onClick_OpenEvCastSED));
        this.programEditor.opusInput.addInlineButton(lang.hitch(this, this._onClick_OpenEvProgramSED));
    }


    private _onChangeTicketsCapacityInput(): void {

        this.addValueOnWidget(this.ticketsCapacity);
    }

    private _onChangeTicketsEstimatedInput(): void {

        this.addValueOnWidget(this.ticketsEstimated);
    }

    private _onChangeOversteeredPriceInput(value: any): void {

        if (this.editedServiceBooking !== null) this.editedServiceBooking["is_oversteered_price"] = this.oversteeredPriceCheckbox.getValue();
        //console.debug("OversteeredPrice", value, this.editedServiceBooking, this.existingEntity);
    }

    private _onChangeSelectedAssociateInputData(): void {

        let value = this.inputSelectedAssociate.getValue();

        if (value == this.originalSelectedAssociateValue) {

            this.UiModder.domClass.add(this.saveAssociate, "w3-disabled");
        } else {

            this.UiModder.domClass.remove(this.saveAssociate, "w3-disabled");
        }

        this.selectedAssociateData["selectedAssociateID"] = value;
    }

    private _onClickSaveAssociateButton(e): void {

        console.debug(this.selectedAssociateData);

        let requestUrl = window.appRoot + "EvBookingEditor/AssignAssociateData";
        this.StandbyStart(this.evTaskAssociateEditorContainer);

        if (this.selectedAssociateData["selectedAssociateID"]) {

            this.RequestManager.post(
                requestUrl,
                {
                    jsonData: JSON.stringify(this.selectedAssociateData)
                },
                lang.hitch(this, this._onAssignAssociateDataResponse),
                lang.hitch(this, this._onAssignAssociateDataError),
                false // sync
            );
        }
    }

    private _onAssignAssociateDataResponse(response): void {

        this.emit("bookingEditorAssignAssociateResponse");
    }

    private _onAssignAssociateDataError(err): void {

        alert(err.Message);
    }

    private _onClickCalculateButton(): void {

        let requestUrl = window.appRoot + "EvBookingEditor/CalculateAndSavePricelistData";
        this.StandbyStart(this.servicePricesEditorContainer);

        if (this.editedServiceBooking != null) {

            this.RequestManager.post(
                requestUrl,
                {
                    jsonData: JSON.stringify(this.editedServiceBooking)
                },
                lang.hitch(this, this._onCalculateAndSavePricelistDataResponse),
                lang.hitch(this, this._onCalculateAndSavePricelistDataError),
                false // sync
            );
        }
    }

    private _onCalculateAndSavePricelistDataResponse(response): void {

        this.emit("bookingEditorPricelistCalculationResponse");
    }

    private _onCalculateAndSavePricelistDataError(err): void {

        alert(err.Message);
    }

    private _onChangepriceDataNumberInputs(): void {

        let price_unit_change = this.numberInput_PriceUnitChange.getValue();
        price_unit_change === null ? this.editedServiceBooking["price_unit_change"] = 0 : this.editedServiceBooking["price_unit_change"] = price_unit_change;

        let price_unit_pricelist = this.numberInput_PriceUnitPricelist.getValue();
        price_unit_pricelist === null ? this.editedServiceBooking["price_unit_pricelist"] = 0 : this.editedServiceBooking["price_unit_pricelist"] = price_unit_pricelist;

        let price_total_pricelist = this.numberInput_PriceTotalPricelist.getValue();
        price_total_pricelist === null ? this.editedServiceBooking["price_total_pricelist"] = 0 : this.editedServiceBooking["price_total_pricelist"] = price_total_pricelist;

        let discount = this.numberInput_Discount.getValue();
        discount === null ? this.editedServiceBooking["discount"] = 0 : this.editedServiceBooking["discount"] = discount;
    }

    private _onPriceCheckboxInputs(): void {

        let bOversteeredPrice = this.oversteeredPriceCheckbox.getValue();
        if (bOversteeredPrice === false) {

            this.freePriceCheckbox.setValue(false, true);
            this.priceTotalPricelistCheckbox.setValue(false, true);
        }

        let bFreePrice = this.freePriceCheckbox.getValue();
        if (bFreePrice === false) {

            this.priceTotalPricelistCheckbox.setValue(false, true);
        }

        let bPriceTotalPricelist = this.priceTotalPricelistCheckbox.getValue();

        if (this.editedServiceBooking !== null) {

            this.editedServiceBooking["is_oversteered_price"] = this.oversteeredPriceCheckbox.getValue();
            this.editedServiceBooking["is_free_price"] = this.freePriceCheckbox.getValue();
            this.editedServiceBooking["is_price_total_pricelist"] = this.priceTotalPricelistCheckbox.getValue();
        }

        this.adjustPricelistEdit(bOversteeredPrice, bFreePrice, bPriceTotalPricelist);
    }

    private adjustPricelistEdit(bOversteeredPrice: boolean, bFreePrice: boolean, bPriceTotalPricelist: boolean): void {

        this.numberInput_PriceUnitChange.setReadonly(true);
        this.numberInput_PriceUnitPricelist.setReadonly(true);
        this.numberInput_PriceTotalPricelist.setReadonly(true);
        this.numberInput_Discount.setReadonly(true);

        if (bOversteeredPrice) {

            this.numberInput_PriceUnitChange.setReadonly(false);
            this.numberInput_Discount.setReadonly(false);
        }
        if (bFreePrice) {

            this.numberInput_PriceUnitChange.setReadonly(true);
            this.numberInput_PriceUnitPricelist.setReadonly(false);
        }
        if (bPriceTotalPricelist) {

            this.numberInput_PriceTotalPricelist.setReadonly(false);
            this.numberInput_PriceUnitPricelist.setReadonly(true);
        }
    }

    private _onChangeTitleInput(): void {

        this.addValueOnWidget(this.bookingTitleInput);
        let value = this.bookingTitleInput.getValue();
        this.setTitles(value ? value : this.translations["BookingEditor__CreateNewBooking"]);
    }

    private refreshOverlappingBookingsView() {
        /*if (this.existingEntity == null) {
            return;
        }*/

        this.overlappingBookingsView.SetParameters({
            start: this.dateStartInput.getValue().date,
            end: this.dateEndInput.getValue().date,
            roomId: this.roomInput.getValue("value"),
            selfBookingId: this.existingEntity?.ID,
            isWithRoomList: false
        });

    }

    private _onOverlappingBookings_DataReceived(entitylist: Array<object>) {
        if (entitylist.length > 0) {
            this.UiModder.domClass.remove(this.overlappingBookingsMessageContainer, "w3-hide");
            this.UiModder.domClass.remove(this.overlappingBookingsViewContainer, "w3-hide");
        } else {
            this.UiModder.domClass.add(this.overlappingBookingsMessageContainer, "w3-hide");
            this.UiModder.domClass.add(this.overlappingBookingsViewContainer, "w3-hide");
        }
    }

    private _onChangeDateStartInput(): void {
        let inputValue = this.dateStartInput.getValue().date;
        this.bookingDateStart = inputValue ? inputValue : null;
        this.handleDateChanges();
        this.addValueOnWidget(this.dateStartInput);

        if (this.bookingDateEnd == null && inputValue != null) {
            let endValue = dojoDate.add(inputValue, "hour", 1);
            this.dateEndInput.setValue(endValue); // enddate is startdate + 1 hour
        }

        if (this.isFullTime.getValue()) this.setFullTime();

        this.refreshOverlappingBookingsView();
    }

    private _onChangeDateEndInput(): void {
        let inputValue = this.dateEndInput.getValue().date;
        this.bookingDateEnd = inputValue ? inputValue : null;
        this.handleDateChanges();
        this.addValueOnWidget(this.dateEndInput);

        if (this.isFullTime.getValue()) this.setFullTime();

        this.refreshOverlappingBookingsView();
    }

    /* aus SelectEnttiyDlg: */
    private _onSelect_Evroom(selectEntityDlg: MdsLax<InstanceType<typeof SelectEntityDialog<VAMtypes.EvRoomEntity>>>, values: Array<any>, items: Array<any>) {
        let value = null;
        if (values && values.length) {
            value = values[0];
        }
        this.serviceEditor.setRoomId(value);

        this.refreshOverlappingBookingsView();
    }

    /* Hintbox: */
    private _onChangeRoomInput(): void {

        let entity: VAMtypes.EvRoom = this.roomInput.getValue("entity");

        this.UiModder.domClass.toggle(this.ticketsSection_container, "w3-hide", !entity || !entity.is_with_public);

        this.addValueOnWidget(this.roomInput);

        if (entity) {
            this.serviceEditor.setRoomId(entity.ID);
        }

        this.refreshOverlappingBookingsView();

        this.audienceSeatingLayoutInput.setRequestParameter("roomId", entity.ID);
        let existingSeatingID = this.audienceSeatingLayoutInput.getValue();

        if (this.existingEntity != null) {
            let booking: VAMtypes.EvBookingEditorEntity = this.existingEntity as VAMtypes.EvBookingEditorEntity;
            existingSeatingID = booking.ref_audience_seating_layouts?.ID;
        }

        this.audienceSeatingLayoutInput.loadListValues(existingSeatingID);
    }

    private _onChangeBookerInput(): void {

        this.addValueOnWidget(this.bookerInput);
    }

    private _onChangeActivityStatusInput(): void {

        this.addValueOnWidget(this.activityStatusInput);
    }

    private _onChangeAudienceSeatingLayoutInput(): void {

        this.addValueOnWidget(this.audienceSeatingLayoutInput);

        let entity: VAMtypes.AudienceSeatingLayout = this.audienceSeatingLayoutInput.getValue(true);
        if (entity != null) {
            let existingCapacy = this.ticketsCapacity.getValue();

            if (existingCapacy != null && existingCapacy != entity.seating_capacity) {
                let dlgConfirm = new GenericDialog();

                dlgConfirm.show(this.translations["BookingEditor_UseCapacityFromSeatingLayout"],
                    this.translations["BookingEditor_UseCapacityFromSeatingLayout__Header"],
                    "",
                    "",
                    "yesno", lang.hitch(this, this._onChangeAudienceSeatingLayout__confirmCallback, entity)
                );
            } else {
                this._onChangeAudienceSeatingLayout__confirmCallback(entity, /*yes*/2);
            }
        }
    }

    private _onChangeAudienceSeatingLayout__confirmCallback(entity: VAMtypes.AudienceSeatingLayout, result) {
        if (result > -1) {
            this.ticketsCapacity.setValue(entity.seating_capacity); // Kapazität aus Bestuhlungsvariante übernehmen

            //
            //irgendwie auf der karteikarte anzeigen, dass etwas automatisch passiert ist
            //
            this.UiModder.domClass.add(this.ticketsCapacity.domNode, "mds-shake");
            this.UiModder.domClass.add(this.ticketsCapacity["labelNode"], "bold");
            setTimeout(() => {
                this.UiModder.domClass.remove(this.ticketsCapacity.domNode, "mds-shake");
                this.UiModder.domClass.remove(this.ticketsCapacity["labelNode"], "bold");
            }, 2000);
        }
    }


    private _onChangeBookingStatusInput(): void {

        this.addValueOnWidget(this.bookingStatusInput);
    }

    private _onChangeEvProjectInputInput(): void {
        this.addValueOnWidget(this.evProjectInput);
    }

    private _onKeyUpNoteInput(evt: KeyboardEvent): void {
        this.addValueOnWidget(this.noteInput);
    }

    setFullTime(): void {

        let useTimeInput: boolean = this.isFullTime.getValue() !== true;

        let timeStart = new Date(null, null, null, 0, 0, 0, 0); //"1970-01-01T00:00:00.000";
        let timeEnd = new Date(null, null, null, 23, 59, 59, 0); //"1970-01-01T23:59:59.000";

        if (useTimeInput) {
            if (this.originalEntityValues && this.originalEntityValues["dateStartInput"]) timeStart = this.originalEntityValues["dateStartInput"];
            else timeStart = new Date();

            if (this.originalEntityValues && this.originalEntityValues["dateEndInput"]) {
                timeEnd = this.originalEntityValues["dateEndInput"];
            } else {
                timeEnd = new Date();
                timeEnd.setHours(timeEnd.getHours() + 1);
            }
        }


        this.dateEndInput.useTimeInput(useTimeInput, timeEnd);
        this.dateStartInput.useTimeInput(useTimeInput, timeStart);
        console.debug("ALL VAL", this.allValues);
    }

    private _onChangeIsFullTime(): void {

        this.addValueOnWidget(this.isFullTime);
        this.setFullTime();
    }

    private _onChangeOnlyVacantRoomsInput(): void {
        let checked = this.onlyVacantRoomsInput.getValue();
        //if (checked !== null) this._setShowOnlyVacantRooms(checked);
        this.addValueOnWidget(this.bookingTitleInput);
    }

    private _onClickButtonShowEntityDialog(evt) {
        this.dataCompletnessCheck();
    }

    private _onClickSendButton(evt?: Event): void {
        // send data
        this.saveFormData();
    }

    saveFormData(): void {
        if (this.isValidationEnabled == true) {
            if (this.dataCompletnessCheck() == true) {

                this._sendFormData();
            }
        } else {
            this._sendFormData();
        }
    }
    // --------------------------inputEvents -----------------------END
    // input requests ------------------------------------------------START

    // input requests ------------------------------------------------END
    // formdata ---------------------------------------------------------START
    adjustSectionsVisibility(): void {

        for (let p in this.bookingListTablesConfig) {

            let config: EvBookingEditor_TableConfig = this.bookingListTablesConfig[p];

            if (!config.isVisible) {

                this.UiModder.domClass.add(config.sectionContainer, "w3-hide");
                this.UiModder.domConstruct.destroy(config.sectionContainer);
            }

            switch (config.name) {
                case EvBookingEditor_ListNames.evTasks:
                    if (config.isVisible) {
                        this.evTaskEditor = new EvTaskEditor();
                        this.evTaskEditor.placeAt(this.evTaskEditor_container);
                        //this.evTaskEditor.addExistingEmployees(); // ich muss ja irgendwie einschleusen, dass ich bestehende Mitarbeiter nicht nochmal auswählen kann
                        // keine Ahnung wo ich die Info in dem Editor bekomme
                        on(this.evTaskEditor, "added", lang.hitch(this, this._onNewBookingListElementFromEditor));
                    }
                    break;
            }
        }
        if (!this.evBookingEditorSectionsConfig?.isBookerSectionVisible) {
            this.bookerInput.setUrl(null);
            this.bookerInput.destroy();
            this.UiModder.domConstruct.empty(this.bookerInput_container);
        }
        //if (this.evBookingEditorSectionsConfig && this.evBookingEditorSectionsConfig.isBookerSectionVisible) this.bookerInput._loadListValues(this.bookerInputPresetValue, this.bookerInputPresetValue === null);
    }

    private drawBookingListTable(allTables: boolean = false, config?: EvBookingEditor_TableConfig): void {

        if (allTables === true) {
            for (let p in this.bookingListTablesConfig) {
                this.drawBookingListTable(false, this.bookingListTablesConfig[p]);
            }
        }

        if (!config || !config.isVisible) return;

        config.tableContainer.innerHTML = null;
        if (config.staticTable != null) {
            config.staticTable.destroy();
        }

        if (this.existingEntity[config.name] === undefined) return;

        config.staticTable = new StaticTable();
        config.staticTable.setFormatter(lang.hitch(this, this.table_formatterFunction));
        config.staticTable.setHeadingLabelFormatter(this.table_formatterFunction__headingLabel);

        config.staticTable.addLineConfig({
            attributes: config.tableLayout.attributes,
            colspans: config.tableLayout.colspans,
            headings: config.tableLayout.headings,
            colNamesInternal: config.tableLayout.headings,
            widths: config.tableLayout.widths,
            alignmentsHeading: config.tableLayout.alignmentsHeading,
            alignmentsRow: config.tableLayout.alignmentsRow,
        });

        this.UiModder.domConstruct.place(config.staticTable.domNode, config.tableContainer);

        let list = [];
        for (let i = 0; i < this.existingEntity[config.name].length; i++) {

            switch (config.name) {
                case EvBookingEditor_ListNames.EvService:
                    let service: VAMtypes.EvServiceBooking = this.existingEntity[config.name][i];
                    let origService: VAMtypes.EvServiceBooking = null // dummy
                    if (this.originalEntityValues != null) {
                        origService = this.originalEntityValues[config.name][i];
                    }

                    if (!service.quantity_text) {

                        if (service.service_type === 1) {
                            service.quantity_text = ` / ${service["quantity"]} ${service.unitCode}`;
                        } else {
                            service.quantity_text = " - ";
                        }
                        if (typeof (origService) != "undefined" && origService.ID === service["ID"]) origService.quantity_text = service["quantity_text"];
                    }

                    if (!service.service_type_text) {
                        service.service_type_text = this.translations[`service_type_${service["service_type"]}`];
                        if (typeof (origService) != "undefined" && origService != null && origService["ID"] === service["ID"]) origService.service_type_text = service.service_type_text;
                    }

                    if (service["state"] != "deleted") {
                        list.push(service);
                    }
                    break;

                default:
                    if (this.existingEntity[config.name][i]["state"] != "deleted") {
                        list.push(this.existingEntity[config.name][i]);
                    }
            }
        }

        config.staticTable.setData(list);

        config.staticTable.setCyAttribute("evBookingEditor");

        if (config.sectionContainer.expander) {
            config.sectionContainer.expander.setMarking(list.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
        }
    }

    setExistingEntity(entity: VAMtypes.EvBookingEditorEntity): void {

        if (entity && entity.ID) {
            this.originalEntityValues = {};

            this.existingEntity = entity;
            this.allValues["ID"] = entity.ID;
            this.originalEntityValues["ID"] = entity.ID;
            this.allValues["Classname"] = entity["Classname"];
            this.originalEntityValues["Classname"] = entity["Classname"];

            for (let p in this.bookingListTablesConfig) {

                let listName: string = this.bookingListTablesConfig[p].name;

                this.allValues[listName] = entity[listName];
                this.originalEntityValues[listName] = lang.clone(entity[listName]);
            }

            this.allValues["newUploadFiles"] = [];
            this.originalEntityValues["newUploadFiles"] = [];

            this.displayExistingEntityValues();

            this.UiModder.domClass.remove(this.deleteButton, "w3-disabled");
        }

    }

    displayExistingEntityValues(): void {

        if (this.editorFormConfig != null) {
            // die values mit dem pithelper holen
            for (let inputName of this.allFields) {
                for (let propertyName in this.editorFormConfig) {
                    if (inputName == propertyName) {
                        let valueToSet: any;

                        valueToSet = this.PitHelper.getEntityAttributeValue(this.existingEntity, this.editorFormConfig[propertyName], "json");

                        if (valueToSet || typeof valueToSet === "boolean") {
                            this.originalEntityValues[inputName] = lang.clone(valueToSet);
                            //console.log("displayExistingEntityValues", inputName, valueToSet);

                            if (inputName == "bookingStatusInput") {
                                this.setBookingStatusPresetVlaue(valueToSet);
                                //this.bookingStatusInput._loadListValues(this.bookingStatusPresetValue, this.bookingStatusPresetValue === null);
                                 this.bookingStatusInput.setValue(valueToSet);

                                continue;
                            } else if (inputName == "activityStatusInput") {
                                this.setActivityStatusPresetValue(valueToSet);
                                //this.activityStatusInput._loadListValues(this.activityStatusPresetValue, this.activityStatusPresetValue === null);
                                this.activityStatusInput.setValue(valueToSet);

                                continue;
                            } else if (inputName == "audienceSeatingLayoutInput") {
                                this.setAudienceSeatingLayoutPresetValue(valueToSet);
                               this.audienceSeatingLayoutInput.setValue(valueToSet);

                                continue;
                            } else if (inputName == "evProjectInput") {
                                this.setEvProjectPresetValue(valueToSet);
                                //this.evProjectInput._loadListValues(this.evProjectPresetValue, this.evProjectPresetValue === null);
                                //if (this.evProjectInput.optionsRegistry.length > 0)
                                this.evProjectInput.setValue(valueToSet);

                                continue;
                            } else if (inputName == "bookerInput") {
                                if (this.evBookingEditorSectionsConfig == null || this.evBookingEditorSectionsConfig.isBookerSectionVisible) {

                                    this.setBookerInputPresetValue(valueToSet);
                                    this.bookerInput.setValue(valueToSet);
                                }

                                continue;
                            }

                            if (this[inputName].setValue) {
                                this[inputName].setValue(valueToSet);
                            } else {
                                // textarea
                                this.UiModder.domAttr.set(this[inputName], "value", valueToSet);
                                this.addValueOnWidget(this[inputName]);
                            }
                        }
                    }
                }
            }
            this.drawBookingListTable(true);
        } else {
            alert("please set the attribute path first (editorFormConfig: {inputName: attributePath, ...})");
        }

    }

    private addValueOnWidget(input): void {

        let widgetName: string = this.getAttachPointNameForWidget(input);

        if (input.getValue) {
            let widgetValue: any = input.getValue();

            if (widgetValue !== null && typeof widgetValue === "boolean") {

                this.allValues[widgetName] = widgetValue;
            }else if (widgetValue && input.validateInput()) {

                if (widgetName == "dateEndInput" || widgetName == "dateStartInput") widgetValue = widgetValue.date;

                this.allValues[widgetName] = widgetValue;
            } else {

                if (widgetName == "ticketsCapacity" || widgetName == "ticketsEstimated") {

                    this.allValues[widgetName] = null;
                } else {

                    delete this.allValues[this.getAttachPointNameForWidget(input)];
                }
            }

        } else if (input.value) {
            this.allValues[widgetName] = input.value;
        }
    }
    private getAttachPointNameForWidget(widget: MdsLax<InstanceType<typeof _StatefulBase>>): string {
        for (let attachPointName of this._attachPoints) {
            if (this[attachPointName] == widget) {
                return attachPointName;
            }
        }
    }



    // check if all the data has been submited
    dataCompletnessCheck(): boolean {

        let result = true;

        let mandatoryKeys = this.mandatoryFields;

        let text: string = "";

        for (let i = 0; i < mandatoryKeys.length; i++) {

            this[mandatoryKeys[i]].setMandatory(true);
            this[mandatoryKeys[i]].validateInput();

            if (!this.allValues.hasOwnProperty(mandatoryKeys[i]) || this[mandatoryKeys[i]].isValid == false) {
                result = false;
            }
        }

        return result;
    }

    checkIsFormDirty(): boolean {

        if (!this.originalEntityValues) return true;
        let originalPropertyNames = Object.getOwnPropertyNames(this.originalEntityValues);
        let actualPropertyNames = Object.getOwnPropertyNames(this.allValues);
        //console.debug("ORIGINAL DATA", this.originalEntityValues);
        //console.debug("ALL VALUES DATA", this.allValues);
        if (originalPropertyNames.length != actualPropertyNames.length) return true;

        for (let propertyName of actualPropertyNames) {

            if (!this.allValues.hasOwnProperty(propertyName)) return true;

            switch (propertyName) {
                case "cast":
                case "program":
                case "service":
                case "evTasks":
                case "evCategories":
                case "orchestraEmployments":
                case "existingFiles":
                case "newUploadFiles":
                    if (JSON.stringify(this.allValues[propertyName]) != JSON.stringify(this.originalEntityValues[propertyName])) return true;
                    break;
                case "roomInput":
                case "evProjectInput":
                    if (this.allValues[propertyName].ID != this.originalEntityValues[propertyName].ID) return true;
                    break;
                case "dateEndInput":
                case "dateStartInput":
                    let strValue: string;
                    if (this.allValues[propertyName] instanceof Date) {
                        strValue = this.dateToLocalISOString(this.allValues[propertyName]);
                    } else if (typeof this.allValues[propertyName] == "string") {
                        strValue = this.allValues[propertyName];
                    }
                    if (this.originalEntityValues[propertyName] != strValue) return true;
                    break;
                default:
                    if (this.allValues[propertyName] != this.originalEntityValues[propertyName]) return true;
                    break;
            }
        }

        return false;
    }


    private _sendFormData(): void {
        //data should be sanitized by now

        this.UiModder.domAttr.set(this.sendButton, "disabled", true);

        if (this._request != null) {
            this._request.cancel();
        }

        let data: object = { ...this.allValues };

        data["dateStartInput"] = this.dateToLocalISOString(data["dateStartInput"]);
        data["dateEndInput"] = this.dateToLocalISOString(data["dateEndInput"]);

        if (this.checkIsFormDirty() == false) {
            console.log("no changes in data: ", data, "||||", this.originalEntityValues);
            this.emit("saveButtonClick_noChanges")
            return;
        }

        this.StandbyStart();

        let jsonData: string = JSON.stringify(data);


        this._request = this.RequestManager.post(
            this.saveDataUrl,
            {
                jsonData: jsonData
            },

            lang.hitch(this, this._onSendFormDataResult),

            lang.hitch(this, function (err: { Message: string }) {
                this.StandbyStop();
                if (err && err.Message && err.Message == "success") {
                    this._onSendFormDataResult(err.Message);
                    return;
                }
                if (err && err.Message) {
                    alert(err.Message);
                } else {
                    console.log(err);
                }
            }),
            false // sync
        );
    }

    private _onSendFormDataResult(response): void {
        this.StandbyStop();

        if (response == "success") {
            this.emit("bookingEditorFormResponse", response);
        } else {
            alert("response: " + response);
            console.log("response: ", response);
        }
    }
    // formdata ---------------------------------------------------------END

    // Layout Manupulation ----------------------------------------------START

    private handleDateChanges(): void {
        if (this.bookingDateStart != null && this.bookingDateEnd != null) {
            this.UiModder.domClass.remove(this.showIfDatesAreSet, "w3-hide");
        } else {
            this.UiModder.domClass.add(this.showIfDatesAreSet, "w3-hide");
        }

        this.roomInput.addAdditionalRequestParameter('dateStart', this.dateToLocalISOString(this.bookingDateStart));
        this.roomInput.addAdditionalRequestParameter('dateEnd', this.dateToLocalISOString(this.bookingDateEnd));
        if (this.existingEntity) {
            this.roomInput.addAdditionalRequestParameter('bookingID', this.existingEntity.ID);
        }
    }
    // Layout Manupulation ----------------------------------------------END
    // heplers -----------------------------------------------start

    //dateToIsoString_noTimeZone(date: Date) {

    //    if (date && Object.prototype.toString.call(date) === "[object Date]") {

    //        if (isNaN(date.getFullYear())) {
    //            throw "Not a valid date";
    //        }

    //        let day = ("0" + date.getDate()).slice(-2); //DD
    //        let month = ("0" + (date.getMonth() + 1)).slice(-2); //MM
    //        let year = date.getFullYear() //YYYY
    //        let hours = ("0" + date.getHours()).slice(-2); // HH
    //        let min = ("0" + date.getMinutes()).slice(-2);  // mm
    //        let sec = ("0" + date.getSeconds()).slice(-2); // ss

    //        // YYYY-MM-DDTHH:mm:ss
    //        let ISOString = `${year}-${month}-${day}T${hours}:${min}:${sec}`;
    //        return ISOString;
    //    }

    //    return null;
    //}

    private setButtonClasses(buttonClasses: string | string[]): void {
        this.UiModder.domClass.add(this.sendButton, buttonClasses);
    }
    private removeButtonClasses(buttonClasses: string | string[]): void {
        this.UiModder.domClass.remove(this.sendButton, buttonClasses);
    }

    //  -------getters && setters --------------------------START
    _setActivityStatusPresetValueAttr(value: string | object): void {
        this.setActivityStatusPresetValue(value);
    }
    _setBookingStatusPresetVlaueAttr(value: string | object): void {
        this.setBookingStatusPresetVlaue(value)
    }
    _setsetEvProjectPresetValueAttr(value: string | object): void {
        this.setEvProjectPresetValue(value)
    }
    setBookerInputPresetValue(value: string | object): void {
        this.bookerInputPresetValue = value;
        this.bookerInput.loadListValues(this.bookerInputPresetValue, false);
    }
    setActivityStatusPresetValue(value: string | object): void {
        this.activityStatusPresetValue = value;
        this.activityStatusInput.loadListValues(this.activityStatusPresetValue, false);
    }
    setAudienceSeatingLayoutPresetValue(value: string | object): void {
        this.audienceSeatingLayoutPresetValue = value;
        this.audienceSeatingLayoutInput.loadListValues(this.audienceSeatingLayoutPresetValue, false);
    }
    setBookingStatusPresetVlaue(value: string | object): void {
        this.bookingStatusPresetValue = value;
        this.bookingStatusInput.loadListValues(this.bookingStatusPresetValue, false);
    }
    setEvProjectPresetValue(value: string | object): void {
        this.evProjectPresetValue = value;
        //if (this.evProjectInput.optionsRegistry.length == 0) this.evProjectInput._loadListValues(this.evProjectPresetValue, false);
    }
    setIValidationEnabled(bool: boolean): void {
        this.isValidationEnabled = bool;
    }
    setIsFormInDialog(bool: boolean): void {
        this._isFormInDialog = bool;

        if (bool == true) {
            this.UiModder.domClass.add(this.sendButtonContainer, "w3-hide");
        } else {
            this.UiModder.domClass.remove(this.sendButtonContainer, "w3-hide");
        }
    }
    setSaveDataUrl(url: string): void {
        this.saveDataUrl = window.appRoot + url;
    }

    private addTooltipsForServiceCheckboxes(): void {

        let tooltip = new Tooltip();
        tooltip.setup({
            content: this.translations["EvBookingditor_CheckboxTooltip_OversteeredPrice"],
            targetnode: this.oversteeredPriceCheckbox.domNode
        });

        tooltip = new Tooltip();
        tooltip.setup({
            content: this.translations["EvBookingditor_CheckboxTooltip_FreePrice"],
            targetnode: this.freePriceCheckbox.domNode
        });

        tooltip = new Tooltip();
        tooltip.setup({
            content: this.translations["EvBookingditor_CheckboxTooltip_PriceTotalPricelist"],
            targetnode: this.priceTotalPricelistCheckbox.domNode
        });

    //    this.UiModder.domClass.add(this.oversteeredPriceCheckbox.labelNodeRight, "w3-tooltip");
    //    this.UiModder.domConstruct.create("span", {
    //        style: "position:absolute;left:22px;bottom:16px; pointer-events:none; z-index: 2; min-width: 300px;",
    //        class: "w3-text w3-tag w3-pale-yellow w3-round w3-animate-opacity w3-border",
    //        innerHTML: this.translations["EvBookingditor_CheckboxTooltip_OversteeredPrice"]
    //    }, this.oversteeredPriceCheckbox.labelNodeRight);

    //    this.UiModder.domClass.add(this.freePriceCheckbox.labelNodeRight, "w3-tooltip");
    //    this.UiModder.domConstruct.create("span", {
    //        style: "position:absolute;left:22px;bottom:16px; pointer-events:none; z-index: 2; min-width: 300px;",
    //        class: "w3-text w3-tag w3-pale-yellow w3-round w3-animate-opacity w3-border",
    //        innerHTML: this.translations["EvBookingditor_CheckboxTooltip_FreePrice"]
    //    }, this.freePriceCheckbox.labelNodeRight);

    //    this.UiModder.domClass.add(this.priceTotalPricelistCheckbox.labelNodeRight, "w3-tooltip");
    //    this.UiModder.domConstruct.create("span", {
    //        style: "position:absolute;left:22px;bottom:16px; pointer-events:none; z-index: 2; min-width: 300px;",
    //        class: "w3-text w3-tag w3-pale-yellow w3-round w3-animate-opacity w3-border",
    //        innerHTML: this.translations["EvBookingditor_CheckboxTooltip_PriceTotalPricelist"]
    //    }, this.priceTotalPricelistCheckbox.labelNodeRight);
    }

    setBookingListTablesConfig(): void {

        let cast: EvBookingEditor_TableConfig = {
            name: EvBookingEditor_ListNames.EvCast,
            staticTable: null,
            tableContainer: this.bookingCastTableContainer,
            sectionContainer: this.castContainer,
            tableLayout: this.castTableLayout,
            isVisible: true
        }
        let program: EvBookingEditor_TableConfig = {
            name: EvBookingEditor_ListNames.EvProgram,
            staticTable: null,
            tableContainer: this.bookingProgramTableContainer,
            sectionContainer: this.programContainer,
            tableLayout: this.programTableLayout,
            isVisible: true
        }
        let service: EvBookingEditor_TableConfig = {
            name: EvBookingEditor_ListNames.EvService,
            staticTable: null,
            tableContainer: this.serviceTableContainer,
            sectionContainer: this.serviceContainer,
            tableLayout: this.serviceTableLayout,
            isVisible: true
        }
        let evTasks: EvBookingEditor_TableConfig = {
            name: EvBookingEditor_ListNames.evTasks,
            staticTable: null,
            tableContainer: this.bookingEvTaskTableContainer,
            sectionContainer: this.evTaskContainer,
            tableLayout: this.evTaskTableLayout,
            isVisible: true
        }
        let evCategories: EvBookingEditor_TableConfig = {
            name: EvBookingEditor_ListNames.evCategories,
            staticTable: null,
            tableContainer: this.bookingEvCategoryTableContainer,
            sectionContainer: this.evCategoryContainer,
            tableLayout: this.evCategoriesTableLayout,
            isVisible: true
        }
        let orchestraEmployments: EvBookingEditor_TableConfig = {
            name: EvBookingEditor_ListNames.orchesterEmployements,
            staticTable: null,
            tableContainer: this.orchesterEmploymentTableContainer,
            sectionContainer: this.orchesterEmploymentContainer,
            tableLayout: this.orchesterEmploymentTableLayout,
            isVisible: true
        }
        let existingFiles: EvBookingEditor_TableConfig = {
            name: EvBookingEditor_ListNames.existingFiles,
            staticTable: null,
            tableContainer: this.bookingFilesTableContainer,
            sectionContainer: this.filesSectionContainer,
            tableLayout: this.existingFilesTableLayout,
            isVisible: true
        }

        this.bookingListTablesConfig = {
            cast: cast,
            program: program,
            service: service,
            evTasks: evTasks,
            evCategories: evCategories,
            orchestraEmployments: orchestraEmployments,
            existingFiles: existingFiles,
        }
    }

    private addDefaultCategoryToFile(file: { guid: string, filenames: string[] }): void {

        file["fileCategories"] = [];
        file["filenames"].forEach(fileName => {

            file["fileCategories"].push({
                fileName: fileName,
                category: this.fileCategories[0].ID
            });
        });
    }

    resetFileUploadInput(): void {

        this.fileUpload.resetFileUpload();
        this.newUploadFiles = [];
    }

    private _onChangeUploadFile(guid) {

        let newFilesArr = this.fileUpload.getValue();

        if (newFilesArr && this.fileUpload.validateInput()) {

            if (this.newUploadFiles.length === 0) {
                this.newUploadFiles = newFilesArr;
                this.newUploadFiles.forEach(file => {

                    this.addDefaultCategoryToFile(file);
                });

                this.allValues["newUploadFiles"] = this.newUploadFiles;
                console.debug("newUploadFiles", this.allValues["newUploadFiles"]);
                return;
            }

            newFilesArr.forEach(file => {

                let guid = file.guid;
                let fileNames = file.filenames
                let existingFile = this.newUploadFiles.filter(x => x["guid"] === guid)[0];

                if (!existingFile) {

                    this.addDefaultCategoryToFile(file);

                    this.newUploadFiles.push(file);
                } else {

                    if (existingFile && existingFile["fileCategories"] && existingFile["fileCategories"].length > fileNames.length) {

                        let catToDelete = existingFile["filenames"].filter(x => fileNames.indexOf(x) === -1);

                        if (catToDelete) existingFile["fileCategories"].splice(existingFile["fileCategories"].indexOf(existingFile["fileCategories"].filter(x => x["fileName"] === catToDelete)[0]), 1);
                    }

                    if (!existingFile["fileCategories"] || existingFile["fileCategories"].length == 0) {

                        this.addDefaultCategoryToFile(existingFile);
                    }
                }
            });

            this.allValues["newUploadFiles"] = this.newUploadFiles;
        } else {

            this.newUploadFiles = [];
            delete this.allValues["newUploadFiles"];
        }

        console.debug("newUploadFiles", this.allValues["newUploadFiles"]);
    }

    private _loadFileCategoriesList(): void {

        let requestUrl = window.appRoot + "EvBookingEditor/GetFileCategoriesList";

        this.RequestManager.post(
            requestUrl,
            {
                jsonData: null
            },
            (response: any) => { this.fileCategories = response },
            (err: any) => { alert(err.Message) },
            false // sync
        );
    }

    protected setupSelectBoxInFileRow(evt: { name: string, row: MdsLax<InstanceType<typeof FileUploadDisplay_ListRow>> }): void {

        let fileRow = evt.row;
        console.debug("fileRow", fileRow);
        let selectBox = new SearchSelect();
        selectBox.setCyName("fileCategories");

        selectBox.labelAttribute = "description";
        selectBox.setLabel("Kat.");
        selectBox.setSelectionListLEGACY(this.fileCategories);

        let categoryToSet = this.fileCategories[0].ID;

        this.allValues["newUploadFiles"].forEach(file => {

            if (file["guid"] === fileRow.getData()["uploadGUID"]) {

                if (file["fileCategories"]) categoryToSet = file["fileCategories"].filter(x => x["fileName"] === fileRow.getData()["FileName"])[0]["category"];
            }
        });

        selectBox.setValue(categoryToSet, true);

        selectBox.on("change", lang.hitch(this, this.assingCategoryToNewFile, fileRow));

        fileRow.addContent_LEGACY(true, selectBox.domNode);
    }

    private assingCategoryToNewFile(fileRow: MdsLax<InstanceType<typeof FileUploadDisplay_ListRow>>, value: string): void {

        let rowFileGuid = fileRow.getData()["uploadGUID"];
        let rowFileName = fileRow.getData()["FileName"];
        let fileToSave = this.allValues["newUploadFiles"].filter(x => x["guid"] === rowFileGuid)[0];

        //if (fileToSave) fileToSave["fileCategoryID"] = value;
        if (fileToSave) fileToSave["fileCategories"].filter(x => x["fileName"] === rowFileName)[0]["category"] = value;

        console.debug("newUploadFiles", this.allValues["newUploadFiles"]);
    }

    private _onClickDeleteButton(evt: MouseEvent) {
        if (!this.existingEntity) {
            return;
        }

        if (!this.hasUserRole("EvBooking_Delete")) {
            return;
        }


        let dlg = new GenericDialog();

        dlg.show(
            this.translations["General_ConfirmDeleteMessage"],
            this.title,
            this.translations["General_ConfirmDeleteSubtitle"],
            "fas fa-exclamation-triangle",
            "yesno",
            lang.hitch(this, this._onConfirmDeletion)
        );
    }

    private _onConfirmDeletion(result: number) {
        if (result >= 2) // ja
        {
            this.deleteEvBooking();
        }
    }

    deleteEvBooking() {
        if (!this.existingEntity || !this.existingEntity.ID) {
            return;
        }
        this.StandbyStart();

        let data = {
            entityID: this.existingEntity.ID
        };

        let url = window.appRoot + "EvBookingEditor/DeleteEvBooking";

        this.RequestManager.post(
            url,
            {
                "jsonData": JSON.stringify(data)
            },
            lang.hitch(this, this._onDeleteEvBookingResponse),
            lang.hitch(this, this._onDeleteEvBookingError),
            false // sync
        );
    }

    private _onDeleteEvBookingResponse(response: { Exception: boolean, Message: string}) {


        this.StandbyStop();


        //if (this.isEmbeddedInTab) {
        //    this.closeTab();
        //}

        this.emit("entityDeleted");
    }

    private _onDeleteEvBookingError(error: more.requestErrorMessage) {
        this.StandbyStop();

        alert(error.Message);
    }

    private _onClick_Form(evt: MouseEvent) {
        topic.publish("/Global/CloseModalMenus");

        evt.stopPropagation();
    }

    private setupExpanderSections() {
        let expander;

        if (this.hasFeature("EvBooking/EvCast")) {

            expander = new ExpandableSection();
            this.castContainer = expander.setupAsReplacement(
                this.castContainer,
                this.translations["BookingEditor__castTableLabel"],
                "medium",
                true, true, false
            );

            console.debug("castContainer", this.castContainer);
        } else {

            this.hideNode(this.castContainer);
        }

        if (this.hasFeature("EvBooking/EvProgram")) {

            expander = new ExpandableSection();
            this.programContainer = expander.setupAsReplacement(
                this.programContainer,
                this.translations["BookingEditor__programTableLabel"],
                "medium",
                true, true, false
            );
        } else {

            this.hideNode(this.programContainer);
        }

        if (this.hasFeature("EvBooking/#EvService")) {

            expander = new ExpandableSection();
            this.serviceContainer = expander.setupAsReplacement(
                this.serviceContainer,
                this.translations["BookingEditor__serviceTableLabel"],
                "medium",
                true, true, false
            );
        } else {

            this.hideNode(this.serviceContainer);
        }



        if (this.hasFeature("EvBooking/OrchesterEmployment")) {

            expander = new ExpandableSection();
            this.orchesterEmploymentContainer = expander.setupAsReplacement(
                this.orchesterEmploymentContainer,
                this.translations["MyEmployments_Title2"],
                "medium",
                true, true, false
            );
        } else {

            this.hideNode(this.orchesterEmploymentContainer);
        }

        if (this.hasFeature("EvBooking/#EvTask")) {

            expander = new ExpandableSection();
            this.evTaskContainer = expander.setupAsReplacement(
                this.evTaskContainer,
                this.translations["BookingEditor__EvTaskTableLabel"],
                "medium",
                true, true, false
            );
        } else {

            this.hideNode(this.evTaskContainer);
        }

        if (this.hasFeature("EvBooking/EvCategory")) {

            expander = new ExpandableSection();
            this.evCategoryContainer = expander.setupAsReplacement(
                this.evCategoryContainer,
                this.translations["BookingEditor__EvCategoryTableLabel"],
                "medium",
                true, true, false
            );
        } else {

            this.hideNode(this.evCategoryContainer);
        }


        if (this.hasFeature("EvBooking/FileManage")) {

            expander = new ExpandableSection();
            this.filesSectionContainer = expander.setupAsReplacement(
                this.filesSectionContainer,
                this.translations["General_Label_Files"],
                "medium",
                true, true, false
            );
        } else {

            this.hideNode(this.filesSectionContainer);
        }
    }

    setTitles(window: string, topbar?: string) {
        super.setTitles.apply(this, arguments as any);

        this.emit("titleChange", window);
    }

    getTitle(): string {
        return this.bookingTitleInput.getValue();
    }

    setEmptyProjectValue(): void {

        let valueToSet = {
            ID: "ignore",
            gDisp_1: this.translations["EvBookingditor_DefaultProject_Label"]
        }
        this.evProjectInput.setValue(valueToSet);
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        on(this.domNode, "click", lang.hitch(this, this._onClick_Form));


        this.activityStatusInput.loadListValues(this.activityStatusPresetValue, this.activityStatusPresetValue === null);
        this.bookingStatusInput.loadListValues(this.bookingStatusPresetValue, this.bookingStatusPresetValue === null);
        //if (this.evBookingEditorSectionsConfig.isBookerSectionVisible) this.bookerInput._loadListValues(this.bookerInputPresetValue, this.bookerInputPresetValue === null);
        //this.evProjectInput._loadListValues(this.evProjectPresetValue, this.evProjectPresetValue === null);


        this.addTooltipsForServiceCheckboxes();
        this.ticketsCapacity.setPlaces(0);
        this.ticketsEstimated.setPlaces(0);


        this.setupHintboxes();
        this.setupExpanderSections();

        this.setBookingListTablesConfig();

        if (window.sessionInfo.getUserRoles().indexOf("BOOKING_EDITOR__HIDE_PROGRAM_CAST") > -1) {
            this.UiModder.domClass.add(this.castContainer, "w3-hide");
            this.UiModder.domClass.add(this.programContainer, "w3-hide");
        }

        if (!this.hasFeature("EvBooking/#SeatingLayout")) this.hideNode(this.audienceSeatingLayoutContainer);
        if (this.hasFeature("EvBooking/DefaultProject")) this.evProjectInput.setReadonly(true);

        this._loadFileCategoriesList();
        //topic.subscribe("FileUploadDisplay/NewRowCreated", lang.hitch(this, this.setupSelectBoxInFileRow))

        this.fileUpload.on("NewRowCreated", lang.hitch(this, this.setupSelectBoxInFileRow));


    //    this.roomInput.addConditionalFormat("is_vacant_on_date", false, "EvRoomNotVacant");
    //    this.roomInput.addConditionalFormat("is_vacant_on_date", true, "EvRoomVacant");
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvBookingEditorForm);
